import React, {Component} from 'react';

export default class CustomTooltip extends Component<{api:any;rowIndex:number;color:string;column:any}> {
    getReactContainerClasses() {
        return ['custom-tooltip'];
    }
    render() {
        const data = this.props.api.getDisplayedRowAtIndex(this.props.rowIndex).data;
        console.log(this.props);
        const note = data[this.props.column.colId + '_BemerkungDE'];
        console.log(note)
        if(note){
            return (
                <div className="gemu-rs-custom-tooltip" style={{backgroundColor: this.props.color || 'white'}}>
                     <p><span>{note}</span></p>
                 </div>
             );
        } else {
            return <div>Keine Bemerkung</div>
        }

    }
}